module.exports = __webpack_public_path__ + "static/media/1165A4.42ba59d1.jpg";